import React from 'react'
import Segment from '../../components/Segment'
import moment from 'moment'
import { Switch, Row, Icon, notification, Modal, Tag } from 'antd'
import { CountdownTimer } from '../../components/CountdownTimer'
import API from '../../services/API'

const INIT = '******'
const NOFOUND = 'Token no encontrado'

const TokenContainer = ({ user }) => {
    const [token, setToken] = React.useState(INIT)
    const [data, setData] = React.useState(null)
    const [value, setValue] = React.useState(false)
    const [loading, setloading] = React.useState(false)
    const [isTokenValid, setIsTokenValid] = React.useState(false) //guarda el estado del token.

    const getData = () => {
        console.log('user', user)
        if (user.role_id == 1) {
            setloading(true)
            API.get(`/api/tokens/user/${user.id}`)
                .then(response => {
                    console.log('-----', response.data)
                    if (Object.entries(response.data).length && response.data) {
                        console.log("--- ready", response.data)
                        setData(response.data)
                        setIsTokenValid(true)
                    } else {
                        setData(null)
                        setIsTokenValid(false)
                    }
                })
                .catch(error => {
                    setData(null)
                    setIsTokenValid(false)
                    console.error(error)
                })
                .finally(() => {
                    setloading(false)
                })
        } else {
            setloading(false)
        }
    }
    // Generamos el token si  no existe, pero antes preguntamos si lo desea generar.
    const generateToken = async () => {
        try {
            setloading(true)
            const response = await API.get(`/api/tokens/user/${user.id}/generate`)
            const { ok, message, payload } = response.data
            notification.success({ message })
            setData(payload)
            setToken(payload.value)
            setIsTokenValid(true)
        } catch (e) {
            if (e.response) {
                notification.error({ message })
            } else if (e.request) {
                notification.error({ message: 'No se recibió respuesta del servidor' })
            } else {
                notification.error({ message: e.message || ' Error desconocido de JS' })
            }
        } finally {
            setloading(false)
        }
    }

    const showModalToken = (title = 'Token no encontrado: ¿Desea generar uno nuevo?') => {
        // Modal del token generado.
        Modal.confirm({
            title,
            okText: 'Generar',
            cancelText: 'Cerrar',
            onOk() {
                generateToken()
            },
            onCancel() {},
        })
    }

    React.useEffect(() => {
        getData()
    }, [])

    React.useEffect(() => {
        if (data && !isTokenValid) {
            showModalToken('El token expiro: ¿Desea generar uno nuevo?')
        }
    }, [isTokenValid])

    return (
        <Segment loading={loading}>
            <div style={{ maxWidth: '550px', margin: '20px auto' }}>
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                        minHeight: '120px',
                        backgroundColor: '#1890ff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <p
                        style={{
                            letterSpacing: '2px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            fontSize: '25px',
                            textTransform: 'uppercase',
                            color: '#fff',
                        }}
                    >
                        Token del día
                    </p>
                    <div
                        style={{
                            width: '50px',
                            height: '50px',
                            border: '3px solid #FFF',
                            borderRadius: '50%',
                            position: 'absolute',
                            bottom: '-25px',
                            left: '0',
                            right: '0',
                            margin: 'auto',
                            display: 'flex',
                            backgroundColor: '#e30613',
                        }}
                    >
                        <Icon type="lock" style={{ fontSize: '30px', color: '#FFF', margin: 'auto' }} />
                    </div>
                </div>
                <div
                    style={{
                        width: '100%',
                        height: '250px',
                        backgroundColor: '#001529',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <span
                        style={{
                            color: '#fff',
                            fontSize: '30px',
                            textAlign: 'center',
                            padding: '20px',
                            letterSpacing: '15px',
                        }}
                    >
                        {data && data.value && token != NOFOUND && token != INIT ? data.value : token}
                    </span>
                    {token != NOFOUND && token != INIT && (
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                {!isTokenValid && (
                                    <Tag color="red" style={{ background: '#e30613', color: '#ffffff' }}>
                                        Vencido
                                    </Tag>
                                )}
                                {isTokenValid && <Tag color="green">Vigente</Tag>}
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    fontSize: '20px',
                                    gap: '5px',
                                    color: '#ffffff',
                                }}
                            >
                                <div>Vence en: </div>
                                {data && (
                                    <div>
                                        <CountdownTimer
                                            onExpiration={() => {
                                                setIsTokenValid(false)
                                            }}
                                            targetDate={moment(data.expires_at).valueOf()}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div style={{ margin: '20px 0px' }}>
                        <Switch
                            style={{ backgroundColor: value ? '#1890ff' : '#607d8b' }}
                            onChange={value => {
                                setValue(value)
                                if (value) {
                                    if (data && data.id) {
                                        setToken(data.value)
                                        if (!isTokenValid) {
                                            showModalToken('El token expiro: ¿Desea generar uno nuevo?')
                                        }
                                    } else {
                                        showModalToken()
                                        setToken(NOFOUND) // Token no encontrado
                                    }
                                } else {
                                    setToken(INIT)
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </Segment>
    )
}

export default TokenContainer
